import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router';
import { Container, Row } from 'reactstrap';
import { Button, PageHeader, Section } from '../../../shared/components';
import GeneralInformationTabContainer from '../../Operations/Operation/GeneralInformationTabContainer';
import MiciCaseDocuments from './Documents';
import Context from './MiciCaseContext';
import MiciCauses from './Causes/MiciCauses';
import PageHeaderSubtitle from '../../../shared/components/PageHeaderSubtitle';
import MiciTimeline from './Timeline/MiciTimeline';
import MiciPhases from './Phases/MiciPhases';

const refreshPage = () => {
  setTimeout(() => {
    window.location.reload();
  }, 500);
};

const MiciCase: React.FC = () => {
  const {
    data: { miciCase },
    loading,
  } = useContext(Context);
  const { t } = useTranslation();
  const location = useLocation();

  const [showAllMilestones, setShowAllMilestones] = useState(true);
  const chevron = showAllMilestones ? 'chevron-up' : 'chevron-down';

  const querySrting = new URLSearchParams(location.search);
  const q = (key: string) => querySrting.get(key);
  const operationId = q('operationId') ? +(q('operationId') || 0) : undefined;

  const linkConvergence = miciCase && (
    <a
      target="_blank"
      href={`https://www.iadb.org/en/mici/complaint-detail?ID=${miciCase.number}`}
      rel="noopener noreferrer"
      title={t('seeInMICIPage')}
    >
      <FontAwesomeIcon icon="external-link-alt" />
    </a>
  );

  let backUrl;
  if (operationId) {
    if (miciCase.operation.miciCaseIds.length === 1) {
      backUrl = `/operations/${miciCase.operation.number}`;
    } else if (miciCase.operation.miciCaseIds.length > 1) {
      backUrl = `/mici-cases?operationNumber=${miciCase.operation.number}`;
    }
  }
  return (
    miciCase && (
      <Container>
        <PageHeader title={miciCase.number} link={linkConvergence} backTimes={1} backUrl={backUrl}>
          <Link to={`/operations/${miciCase.operation.number}`}>
            <div className="mt-n2" style={{ color: '#0099d6', fontSize: '14px' }}>
              {miciCase.operation.number}
            </div>
          </Link>
          <PageHeaderSubtitle
            className="mb-0"
            items={[
              { value: miciCase.operation.name, label: 'operationName' },
              { value: miciCase.status, label: 'miciStatus' },
              { value: miciCase.operation.stage, label: 'operationStage' },
            ]}
          />
          {miciCase.operation.relateds && miciCase.operation.relateds.length > 0 && (
            <div className="page-subtitle">
              <span id="phase" className="bold">
                {`${t('relatedOperations')}:`}&nbsp;
              </span>
              {miciCase.operation.relateds.map((r, index) => (
                <>
                  {index > 0 && <span className="divider">,&nbsp;</span>}
                  <Link
                    key={r.number}
                    to={`/operationas/${r.number}`}
                    id={r.number}
                    className="mt-n2"
                    style={{ color: '#0099d6', fontSize: '14px' }}
                    onClick={refreshPage}
                  >
                    <span>{r.number}</span>
                  </Link>
                </>
              ))}
            </div>
          )}
        </PageHeader>
        <Row>
          <Section>
            <GeneralInformationTabContainer operation={miciCase.operation} loading={loading} />
          </Section>
        </Row>
        <Row>
          <Section title="MICI Data">
            <div className="px-3">
              {miciCase.phases && (
                <div className="mb-3">
                  <h5>Timeline</h5>
                  <MiciTimeline phases={miciCase.phases} currentPhase={miciCase.stage} />
                  <Button
                    className="btn-tertiary pl-1"
                    iconRight={chevron}
                    text={t('viewAllMilestones')}
                    type="button"
                    onClick={() => setShowAllMilestones((current) => !current)}
                  />
                  {showAllMilestones && (
                    <MiciPhases phases={miciCase.phases} currentPhase={miciCase.stage} />
                  )}
                </div>
              )}

              <MiciCauses />
              <MiciCaseDocuments />
            </div>
          </Section>
        </Row>
      </Container>
    )
  );
};

export default MiciCase;
